import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { getOffsetRect } from '../helpers';
import * as ModalsActions from '../modals/ModalsActions';
import AgentComponent from './AgentComponent';
import * as AgentActions from './AgentActions';
import './Style';

class AgentContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            agentType: Object.freeze({
                agent: 'agent',
                colister: 'colister'
            }),
            toastId: null,
            error: null,
            errorInfo: null
        }

        this.contactAgent = this.contactAgent.bind(this);
        this.openContactFullscreen = this.openContactFullscreen.bind(this);
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        }, () => {
            console.error(error, errorInfo);
        })
    }

    contactAgent(sender, agentType, token) {
        this.props.agentActions.contactAgent(sender, agentType, token);
        if (!toast.isActive(this.state.toastId)) {
            this.setState({
                toastId: toast.success('Mail has been sent.')
            });
        }
    }

    openContactFullscreen(id, element, agentType) {
        this.props.agentActions.navigateToContact({
            id,
            top: getOffsetRect(element).top
        }, agentType);
    }

    render () {
        const { agentInfo, colisterInfo, reCaptcha_key } = this.props;
        const { agentType, error } = this.state;

        if (error) {
            return null;
        }

        if ((!agentInfo.email && !agentInfo.name && !agentInfo.company)
            && (!colisterInfo.email && !colisterInfo.name && !colisterInfo.company)) {
                return null;
            }

        return (
            <div id='contact' className="agent-container" ref={contact => this.contact = contact}>
                <h2 className="section-header">Presented by</h2>
                <div className="agent-content">
                    <AgentComponent
                        agentInfo={agentInfo}
                        agentType={agentType.agent}
                        contactAgent={this.contactAgent}
                        openContactFullscreen={this.openContactFullscreen}
                        reCaptcha_key={reCaptcha_key}
                    />
                    <AgentComponent
                        agentInfo={colisterInfo}
                        agentType={agentType.colister}
                        contactAgent={this.contactAgent}
                        openContactFullscreen={this.openContactFullscreen}
                        reCaptcha_key={reCaptcha_key}
                    />
                </div>
            </div>
        )
    }
}

AgentContainer.propTypes = {
    agentInfo: PropTypes.object,
    colisterInfo: PropTypes.object
}

const mapStateToProps = (state) => {
    return {
        agentInfo: state.agent.agentInfo,
        colisterInfo: state.agent.colisterInfo,
        reCaptcha_key: state.app.reCaptcha_key
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        agentActions: bindActionCreators(AgentActions, dispatch),
        modalsActions: bindActionCreators(ModalsActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentContainer)